import React, { useCallback, useState } from 'react';
import { faSlidersH, faCropAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useIsCrop from 'components/editors/NewEditor/hooks/useIsCrop';
import { useAdmin, useMode, useUpdateShape } from 'hooks';
import { modes } from 'constants/index';
import Toggle from 'react-toggle';
import SliderStyle from '../components/SliderStyle';
import './ActionBarDropZone.scss';
import ShapeLock from '../components/ShapeLock';
import ShapeDelete from '../components/ShapeDelete';
import ActionsContainer, { SubActionsContainer } from '../components/ActionsContainer';
import FitImage from '../components/FitImage';
import OrderObjects from '../components/OrderObjects';
// eslint-disable-next-line no-unused-vars
// import ResetCropping from '../components/ResetCropping';
// import Effects from '../components/Effects';

const NumberInput = ({ label, value, onChange }) => (
  <div>
    {label}:
    <input
      className="number-input"
      type="number"
      value={value}
      onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
    />
  </div>
);

export const ActionBarDropZone = ({ hide, shape }) => {
  const { image } = shape;
  const hasImage = Boolean(image);
  const [, toggleIsCrop] = useIsCrop();
  const onChange = useUpdateShape(shape.id);
  const [showAdjust, setShowAdjust] = useState(false);
  const mode = useMode();
  const admin = useAdmin();
  const toggleShowAdjust = useCallback(() => setShowAdjust((prev) => !prev), []);

  return (
    <>
      <ActionsContainer hide={hide}>
        {hasImage && (
          <>
            <div className="icon-button-container" onClick={toggleShowAdjust}>
              <FontAwesomeIcon className="icon-button" icon={faSlidersH} />
              <p>Adjust</p>
            </div>
            {/* <Effects shape={shape} /> */}
            <FitImage shape={shape} />
            {/* <ResetCropping shape={shape} /> */}
            <div className="icon-button-container" onClick={toggleIsCrop}>
              <FontAwesomeIcon className="icon-button" icon={faCropAlt} />
              <p>Crop</p>
            </div>
          </>
        )}
        <OrderObjects />
        {admin && (
          <>
            <NumberInput label="x" value={shape.x} onChange={(val) => onChange({ x: val })} />
            <NumberInput label="y" value={shape.y} onChange={(val) => onChange({ y: val })} />
            <NumberInput label="H" value={shape.height} onChange={(val) => onChange({ height: val })} />
            <NumberInput label="W" value={shape.width} onChange={(val) => onChange({ width: val })} />
          </>
        )}
        <ShapeLock object={shape} />
        {mode !== modes.photoPrint ? <ShapeDelete /> : null}
      </ActionsContainer>
      {hasImage && (
        <SubActionsContainer
          actionClassName="action-adjust"
          show={showAdjust}
          clickAway={(e) => {
            e.stopPropagation();
            toggleShowAdjust();
          }}
        >
          <div className="edit-contrast">
            <SliderStyle
              key="sliderContrast"
              objectId={shape.id}
              image={image}
              label="Contrast"
              parameter="contrast"
              min={-50}
              max={50}
            />
            <SliderStyle
              key="sliderBrightness"
              objectId={shape.id}
              image={image}
              label="Brightness"
              parameter="brightness"
              min={-50}
              max={50}
            />
            {!image.isBW ? (
              <SliderStyle
                key="sliderSaturation"
                objectId={shape.id}
                image={image}
                label="Saturation"
                parameter="saturation"
                min={-100}
                max={50}
              />
            ) : null}
          </div>
          <div style={{ display: 'flex', width: '100%', padding: '5px' }}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
              <label>Black and White</label>
            </div>

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Toggle
                className="toggle-switch"
                checked={!!image.isBW}
                onChange={() => onChange({ image: { isBW: !image.isBW } })}
              />
            </div>
          </div>
        </SubActionsContainer>
      )}
    </>
  );
};

export default ActionBarDropZone;
